import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Admin from "../store/ducks/admin.duck";
import * as Forms from "../store/ducks/forms.duck";
import { Alert, Button, Form, Row, Col, Modal } from "react-bootstrap";
import {
  Paper,
  Box,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
  Tooltip,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";
import FormDataEntry from "../pages/home/admin/FormDataEntry";
import { CircularProgress } from "@material-ui/core";
import DocumentIcon from "@material-ui/icons/Description";
import CloudDownload from "@material-ui/icons/CloudDownload";
import DescriptionIcon from "@material-ui/icons/Description";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import CloseIcon from "@material-ui/icons/Close";
import Delete from "@material-ui/icons/Delete";
import { format } from "date-fns";
import { saveAs } from "file-saver";

import "../../_metronic/_assets/css/app2.css";

export default function Files(props) {
  const linkStyle = {
    color: "#0056b3",
    textDecoration: "none",
  };

  const dispatch = useDispatch();
  useEffect(() => {
    if (props.pkid > 0) dispatch(Admin.actions.fetchFiles({ type: props.type, pkID: props.pkid }));
  }, [dispatch, props.type, props.pkid]);
  useEffect(() => {
    dispatch(Forms.actions.fetchForms());
  }, [dispatch]);
  useEffect(() => {
    if (props.pkid > 0) dispatch(Admin.actions.fetchCSPathwayFiles({ type: props.type, pkID: props.pkid }));
  }, [dispatch, props.type, props.pkid]);

  const role = useSelector((state) => state.auth.roleDesc);
  const csPathwayFiles = useSelector((state) => state.admin.CSPathwayFiles);
  const inviteStatus = props.inviteStatus ? props.inviteStatus : "none";

  var [newFile, setNewFile] = useState("");
  var [mhcp, setmhcp] = useState(0);
  const forms = useSelector((state) => state.forms.Forms);
  // Will need to add more to this filter as they are developed
  const pdfForms = forms.filter(
    (form) =>
      form.formDataPlugin === "Referring GP Letter" ||
      form.formDataPlugin === "Referring GP Ad-Hoc Letter" ||
      form.formDataPlugin === "Referring GP No Contact Letter",
  );
  const [sendFormID, setSendFormID] = useState(0);
  const [showFormData, setShowFormData] = useState(false);
  const [formData, setFormData] = useState();
  const [fileData, setFileData] = useState();
  const [fileDataName, setFileDataName] = useState();
  const [showFileData, setShowFileData] = useState(false);
  const [showCompleteForm, setShowCompleteForm] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteFileId, setDeleteFileId] = useState();
  const [deleteFileName, setDeleteFileName] = useState();
  const [selectedForm, setSelectedForm] = useState();
  const files = useSelector((state) => state.admin.Files[props.type]);
  const subType = props.subtype && props.subtype === "NDIS" ? "NDIS" : "notset";

  const fetchFormPDFFile = useSelector((state) => state.forms.FormPDF);
  const fetchFormPDFStatus = useSelector((state) => state.forms.FetchFormPDFStatus);
  const fetchFileDownload = useSelector((state) => state.admin.FetchFileDownload);
  const fetchFileDownloadStatus = useSelector((state) => state.admin.FetchFileDownloadStatus);
  const [activeDownloadId, setActiveDownloadId] = useState(null);
  const [activeFileDownloadId, setActiveFileDownloadId] = useState(null);
  const [downloadFileName, setDownloadFileName] = useState("");
  const [downloadName, setDownloadName] = useState("");
  const [fileAction, setFileAction] = useState(null);

  function handleFileFieldChange(propertyName, event) {
    // console.log(event.currentTarget.files[0]);
    setNewFile(event.currentTarget.files[0]);
  }

  function handleConfirmationClose() {
    setShowConfirmation(false);
  }

  function addFile() {
    // Move from useState to FormData
    const formData = new FormData();
    // Add fields
    // console.log(newFile);
    formData.append("type", props.type);
    formData.append("pkid", props.pkid);
    formData.append("newfile", newFile);
    formData.append("mhcpFlag", mhcp);
    // Ok Time to Dispatch
    process.env.REACT_APP_DEBUG && console.log(...formData);
    dispatch(Admin.actions.postFile({ formData: formData, type: props.type, pkID: props.pkid }));
    setNewFile("");
  }

  function completeForm() {
    setShowCompleteForm(true);
    setSelectedForm(forms.filter((form) => form.id === sendFormID)[0].formName);
    // console.log(forms.filter(form => form.id === sendFormID));
  }

  const handleSelectForm = (event, row) => {
    setSendFormID(event.target.value);
  };

  function DeleteFeature(props) {
    // Do not display delete icon for clients
    if (role === "Client") {
      return null;
    }
    return (
      <Tooltip title="Delete" aria-label="Delete" placement="top" arrow>
        <Delete onClick={() => deleteConfirmation(props.id)} style={{ color: "#646c9a", cursor: "pointer", marginLeft: 14 }} />
      </Tooltip>
    );
  }

  const getFileExtension = (filename) => {
    if (!filename) return "";
    const parts = filename.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  };

  const getMimeType = (extension) => {
    const mimeTypes = {
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      csv: "text/csv",
      txt: "text/plain",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      zip: "application/zip",
    };

    return mimeTypes[extension] || "application/octet-stream";
  };

  const closeFileViewer = () => {
    setShowFileData(false);

    if (fileData) {
      URL.revokeObjectURL(fileData);
      setFileData(null);
    }
  };

  const handleFileDownload = (row) => {
    setDownloadFileName(row.filename);
    setFileAction("download");
    setActiveFileDownloadId(row.id);
    dispatch(
      Admin.actions.fetchFileDownload({
        type: props.type,
        pkid: props.pkid,
        fileID: row.id,
      }),
    );
  };

  const handleDownload = (row) => {
    // console.log(row.formData);
    setDownloadName(row.formData.formName);
    setActiveDownloadId(row.id);
    dispatch(
      Forms.actions.fetchFormPDF({
        formId: row.formData.formID,
        id: row.formData.id,
      }),
    );
  };

  function handleCheckBoxChange(id, currentState) {
    // console.log(id)
    // console.log(currentState)
    dispatch(Admin.actions.setFileClientViewableFlag({ id: id, current: currentState, type: props.type, pkID: props.pkid }));
  }

  // Look for form PDF download completion and trigger download if ready
  useEffect(() => {
    if (fetchFormPDFStatus === "Fetched" && fetchFormPDFFile && fetchFormPDFFile !== "") {
      downloadPDF();
      setActiveDownloadId(null);
      dispatch(Forms.actions.resetFormPDFDownloadStatus());
    }
  }, [fetchFormPDFStatus, fetchFormPDFFile, downloadPDF, dispatch]);

  // Look for file download completion and trigger download if ready
  useEffect(() => {
    if (fetchFileDownloadStatus === "Fetched" && fetchFileDownload && fetchFileDownload.filerequested) {
      if (fileAction === "download") {
        downloadFile();
      }
      if (fileAction === "open") {
        openFile();
      }
      setActiveFileDownloadId(null);
      setFileAction(null);
      dispatch(Admin.actions.resetFileDownloadStatus());
    }
  }, [fetchFileDownloadStatus, fetchFileDownload, fileAction, downloadFile, openFile, dispatch]);

  // This is used to download Files in whatever format
  const downloadFile = useCallback(() => {
    if (fetchFileDownload && fetchFileDownload.filerequested) {
      const byteCharacters = atob(fetchFileDownload.filerequested);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const extension = getFileExtension(downloadFileName);
      const mimeType = getMimeType(extension);
      const file = new Blob([byteArray], {
        type: mimeType,
      });

      saveAs(file, downloadFileName);
      // const today = new Date();
      // const formattedDate = today.toISOString().split("T")[0];
      // saveAs(file, `${downloadFileName} ${formattedDate}.pdf`);
    }
  }, [fetchFileDownload, downloadFileName]);

  const openFile = useCallback(() => {
    if (fetchFileDownload && fetchFileDownload.filerequested) {
      const byteCharacters = atob(fetchFileDownload.filerequested);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const extension = getFileExtension(downloadFileName);
      const mimeType = getMimeType(extension);

      const file = new Blob([byteArray], {
        type: mimeType,
      });

      const url = URL.createObjectURL(file);

      setFileData(url);
      setFileDataName(downloadFileName);
      setShowFileData(true);
    }
  }, [fetchFileDownload, downloadFileName]);

  // This is used to download Forms in PDF format
  const downloadPDF = useCallback(() => {
    if (fetchFormPDFFile && fetchFormPDFFile.exportPDF) {
      const byteCharacters = atob(fetchFormPDFFile.exportPDF);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const file = new Blob([byteArray], {
        type: "application/pdf",
      });

      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      saveAs(file, `${fetchFormPDFFile.fileName} ${formattedDate}.pdf`);
    }
  }, [fetchFormPDFFile, downloadName]);

  const loadFormData = (file) => {
    // Check if formData or download link
    // Display form data entry modal
    setFormData(file.formData);
    setShowFormData(true);
  };

  const handleFileOpen = (row) => {
    setFileAction("open");
    setDownloadFileName(row.filename);
    setActiveFileDownloadId(row.id);
    dispatch(
      Admin.actions.fetchFileDownload({
        type: props.type,
        pkid: props.pkid,
        fileID: row.id,
      }),
    );
  };

  function deleteConfirmation(delId) {
    setDeleteFileId(delId);
    setDeleteFileName(files.filter((file) => file.id === delId)[0].filename);
    // console.log('Files')
    // console.log(delId)
    // console.log(files.filter(file => file.id === delId)[0].filename)
    setShowConfirmation(true);
  }

  function deleteFile() {
    // Soft delete file
    // console.log(id);
    dispatch(Admin.actions.deleteFile({ id: deleteFileId, type: props.type, pkID: props.pkid }));
    setShowConfirmation(false);
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 200,
      // maxWidth: 200,
    },
    media: {
      height: 200,
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  }));

  const classes = useStyles();

  const IconWrapper = React.forwardRef(({ children }, ref) => (
    <span
      ref={ref}
      style={{
        marginRight: 12,
        display: "flex",
        alignItems: "center",
      }}
    >
      {children}
    </span>
  ));

  const shortenFileName = (fileName) => {
    if (!fileName || fileName.length <= 30) {
      return fileName;
    }

    return `${fileName.substring(0, 18)}...${fileName.substring(fileName.length - 9)}`;
  };

  return (
    <>
      <Grid container spacing={4}>
        <Grid item md={props.vertical ? 12 : 4}>
          <Row>
            <Col md="12">
              <Form.Group>
                <Form.Label>Add File:</Form.Label>
                <Grid container className="file-upload-form">
                  <Grid
                    item
                    md={8}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      minWidth: 0,
                    }}
                  >
                    <label
                      htmlFor="newfile"
                      style={{
                        display: "inline-block",
                        padding: "6px 12px",
                        margin: 0,
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        borderRadius: 4,
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                    >
                      Choose File
                    </label>

                    <input id="newfile" type="file" name="newfile" onChange={(event) => handleFileFieldChange("newfile", event)} style={{ display: "none" }} />

                    {newFile && (
                      <span
                        style={{
                          display: "inline-block",
                          marginLeft: 12,
                          verticalAlign: "middle",
                          maxWidth: "none",
                          whiteSpace: "nowrap",
                        }}
                        title={newFile.name}
                      >
                        {shortenFileName(newFile.name)}
                      </span>
                    )}
                  </Grid>
                  {props.vertical ? (
                    <Grid item md={2}>
                      <Button variant="success" size="sm" onClick={() => addFile()}>
                        Upload
                      </Button>
                    </Grid>
                  ) : null}
                </Grid>
              </Form.Group>
            </Col>
            {props.type === "Client" ? (
              <Col md="12">
                <Form.Group>
                  <Checkbox
                    aria-label="Mental Health Care Plan"
                    name="mhcp"
                    value={mhcp}
                    onChange={(event) => setmhcp(event.target.checked)}
                    style={{ paddingTop: 6, paddingLeft: 0 }}
                  />
                  {subType && subType === "NDIS" ? (
                    <span style={{ paddingBottom: 4 }}>This is the current NDIS Plan</span>
                  ) : (
                    <span style={{ paddingBottom: 4 }}>This is the current Mental Health Care Plan</span>
                  )}
                </Form.Group>
              </Col>
            ) : null}
            {props.vertical ? null : (
              <Col md="12">
                <Grid container spacing={0} padding={6} justifyContent="space-between">
                  <Grid item></Grid>
                  <Grid item>
                    <Button variant="success" size="sm" onClick={() => addFile()}>
                      Upload
                    </Button>
                  </Grid>
                </Grid>
              </Col>
            )}
          </Row>
          {role !== "Client" && role !== "Referrer" && (inviteStatus === "Sent" || inviteStatus === "none") ? (
            <>
              <hr />
              {pdfForms && pdfForms.length > 0 ? (
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <FormControl variant="outlined" margin="dense">
                        <Form.Label>Generate PDF:</Form.Label>
                        <Select
                          id="sendFormID"
                          aria-label="Select Action Type"
                          name="sendFormID"
                          value={sendFormID}
                          onChange={handleSelectForm}
                          style={{ backgroundColor: "white", minWidth: 150 }}
                        >
                          <MenuItem key={0} value={0}></MenuItem>
                          {pdfForms.map((row) => {
                            return (
                              <MenuItem key={`form-${row.id}`} value={row.id}>
                                {row.formName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                  {sendFormID !== 0 ? (
                    <Col md="12">
                      <Grid container spacing={0} padding={6} justifyContent="space-between">
                        <Grid item></Grid>
                        <Grid item>
                          <Button variant="success" size="sm" onClick={() => completeForm()}>
                            Display Form
                          </Button>
                        </Grid>
                      </Grid>
                    </Col>
                  ) : null}
                </Row>
              ) : null}
            </>
          ) : null}
        </Grid>
        <Grid item md={props.vertical ? 12 : 8}>
          {/* <hr style={{ marginTop: 40 }}></hr> */}
          <Alert
            variant="info"
            style={{
              display: csPathwayFiles && csPathwayFiles.pathways_url && csPathwayFiles.pathways_url.length > 0 ? "block" : "none",
              backgroundColor: "#e6f4ff",
              borderColor: "#b3e0ff",
            }}
          >
            <ul style={{ listStyleType: "none", paddingLeft: 0, margin: 0 }}>
              <li style={{ marginBottom: 12 }}>
                <DocumentIcon style={{ marginRight: 10, color: linkStyle.color }} />
                <a href={csPathwayFiles.pathways_url} download style={linkStyle}>
                  Centres Emergency Pathways Document
                </a>
              </li>
              <li style={{ marginTop: 4 }}>
                <DocumentIcon style={{ marginRight: 10, color: linkStyle.color }} />
                <a href={`https://files.ruralhealthconnect.com.au/fileStoreRHC/${csPathwayFiles.image_url}`} download style={linkStyle}>
                  Centralised Service Escalation Pathways
                </a>
              </li>
            </ul>
          </Alert>

          <Form.Group>
            <Form.Label>Files</Form.Label>
            <Paper>
              <TableContainer style={{ backgroundColor: "#FFF", height: props.vertical ? 300 : 540, width: "100%", overflowY: "scroll" }}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>File</TableCell>
                      {props.type === "Client" ? <TableCell>Type</TableCell> : null}
                      {props.type === "Client" && role !== "Client" && props.specialistType !== "centralisedservice" ? (
                        <TableCell>Client View</TableCell>
                      ) : null}
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {files
                      ? files.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{format(new Date(row.createdOn), "dd-MM-yyyy HH:mm")}</TableCell>
                            <TableCell>{row.filename}</TableCell>
                            {props.type === "Client" ? (
                              <TableCell>{subType && subType === "NDIS" && row.mhcpFlag === "MHCP" ? "NDIS Plan" : <>{row.mhcpFlag}</>}</TableCell>
                            ) : null}
                            {props.type === "Client" && role !== "Client" && props.specialistType !== "centralisedservice" ? (
                              <TableCell>
                                {!row.formData ? (
                                  <Checkbox checked={row.clientViewable === "1"} onClick={() => handleCheckBoxChange(row.id, row.clientViewable)} />
                                ) : null}
                              </TableCell>
                            ) : null}
                            <TableCell>
                              <Box display="flex" alignItems="center" whiteSpace="nowrap">
                                {/* {!row.formData && row.downloadlink !== ''&& <OpenInBrowserIcon style={{ color: '#646c9a', cursor: 'pointer' }} onClick={() => loadDataEntry(row.formData)} />} */}
                                {row.formData ? (
                                  <>
                                    {props.type === "Client" ? (
                                      <Tooltip title="Download" aria-label="Download" placement="top" arrow>
                                        {activeDownloadId === row.id ? (
                                          <IconWrapper>
                                            <CircularProgress size={18} />
                                          </IconWrapper>
                                        ) : (
                                          <IconWrapper>
                                            <CloudDownload
                                              style={{ color: "#646c9a", marginLeft: 14, cursor: "pointer" }}
                                              onClick={() => handleDownload(row)}
                                            />
                                          </IconWrapper>
                                        )}
                                      </Tooltip>
                                    ) : null}
                                    <IconWrapper>
                                      <DescriptionIcon style={{ color: "#646c9a", cursor: "pointer" }} onClick={() => loadFormData(row)} />
                                    </IconWrapper>
                                  </>
                                ) : (
                                  <>
                                    <Tooltip title="Open" aria-label="Open" placement="top" arrow>
                                      <OpenInBrowserIcon style={{ color: "#646c9a", cursor: "pointer" }} onClick={() => handleFileOpen(row)} />
                                    </Tooltip>
                                  </>
                                )}
                                {!row.formData ? (
                                  <Tooltip title="Download" aria-label="Download" placement="top" arrow>
                                    {activeFileDownloadId === row.id ? (
                                      <IconWrapper>
                                        <CircularProgress size={18} />
                                      </IconWrapper>
                                    ) : (
                                      <IconWrapper>
                                        <CloudDownload
                                          style={{ color: "#646c9a", marginLeft: 14, cursor: "pointer" }}
                                          onClick={() => handleFileDownload(row)}
                                        />
                                      </IconWrapper>
                                    )}
                                  </Tooltip>
                                ) : null}
                                {!row.formData && <DeleteFeature id={row.id} />}
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Form.Group>
        </Grid>
      </Grid>

      <Modal show={showFormData} onHide={() => setShowFormData(false)} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>{formData && formData.formName}</Modal.Title>
          <Button
            variant="outlined"
            size="sm"
            style={{ marginTop: 5, background: "#eeeeee", border: "1px solid #9da8e5", padding: 5, marginLeft: 10 }}
            onClick={() => setShowFormData(false)}
          >
            <CloseIcon />
          </Button>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          {formData && <FormDataEntry formID={formData.formID} formDataID={formData.formDataID} setShowFormData={setShowFormData} />}
        </Modal.Body>
      </Modal>

      <Modal show={showFileData} onHide={closeFileViewer} dialogClassName="large-pdf-modal" centered>
        <Modal.Header>
          <Modal.Title>{fileDataName}</Modal.Title>
          <Button
            variant="outlined"
            size="sm"
            style={{
              marginTop: 5,
              background: "#eeeeee",
              border: "1px solid #9da8e5",
              padding: 5,
              marginLeft: 10,
            }}
            onClick={closeFileViewer}
          >
            <CloseIcon />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <iframe src={fileData} title="File Viewer" width="100%" height="100%" style={{ border: "none" }} />
        </Modal.Body>
      </Modal>

      <Modal show={showCompleteForm} onHide={() => setShowCompleteForm(false)} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>Generating {selectedForm && selectedForm} PDF</Modal.Title>
          <Button
            variant="outlined"
            size="sm"
            style={{ marginTop: 5, background: "#eeeeee", border: "1px solid #9da8e5", padding: 5, marginLeft: 10 }}
            onClick={() => setShowCompleteForm(false)}
          >
            <CloseIcon />
          </Button>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          <FormDataEntry
            formID={sendFormID}
            formDataID={0}
            setShowFormData={setShowCompleteForm}
            contextName={props.type}
            contextID={props.pkid}
            pdfFlag={true}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showConfirmation} onHide={handleConfirmationClose} dialogClassName="edit-md-sm-dialog-modal">
        <Modal.Header className="edit-md-sm-modal">
          <Modal.Title>Delete File Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          <Grid item md={12}>
            <p>
              Delete File: <span style={{ fontWeight: 600 }}>{deleteFileName}</span>?
            </p>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="edit-md-modal">
          <Button variant="secondary" onClick={handleConfirmationClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={() => deleteFile()}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
